import React, { Fragment } from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import Configurador from './containers/Configurador/Configurador.js';
import Municipal48h from './containers/Municipal48h/Municipal48h';
import Municipal8d from './containers/Municipal8d/Municipal8d';
import MapaPrediccio from './containers/MapaPrediccio/MapaPrediccio';
import MapaRadar from './containers/MapaRadar/MapaRadar';
import MapaAvisos from './containers/MapaAvisos/MapaAvisos';
import MapaAramet from './containers/MapaAramet/MapaAramet';

import { getEnvironment } from './config/environment';
const { ROUTER_BASENAME } = getEnvironment();

const App = () => {
    return (
        <Fragment>
            <div className="App">
                <Router basename={ROUTER_BASENAME}>
                    <Switch>
                        <Route
                            exact
                            path="/"
                            component={props => <Configurador {...props} />}
                        />
                        <Route
                            path="/municipal72h"
                            component={props => <Municipal48h {...props} />}
                        />
                        <Route
                            path="/municipal8d"
                            component={props => <Municipal8d {...props} />}
                        />
                        <Route
                            path="/mapaPrediccio"
                            component={props => <MapaPrediccio {...props} />}
                        />
                        <Route
                            path="/mapaRadar"
                            component={props => <MapaRadar {...props} />}
                        />
                        <Route
                            path="/mapaAvisos"
                            component={props => <MapaAvisos {...props} />}
                        />
                        <Route
                            path="/mapaAramet"
                            component={props => <MapaAramet {...props} />}
                        />
                    </Switch>
                </Router>
            </div>
        </Fragment>
    );
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js